class Token {
  //token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTY4MTU3ODgsInVzZXJuYW1lIjoiYWRtaW4ifQ.9DoeqRYJDOUByjKeim5r9kVb1L1nEAv4d_LZkgXtH40";
  token = null;
  constructor() {
    this.id = Math.random();
  }
  set(token) {
    this.token = token;
    return true;
  }
  get() {
    return this.token;
  }
}

export default new Token();
